import { __awaiter, __decorate } from "tslib";
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { Positions } from '@slickdeals/durango/dist/javascript/utilities/positioning';
import BlueprintComponent from '@slickdeals/blueprint-twig/javascript/core/blueprintComponent';
import Tooltip from '@slickdeals/blueprint-twig/javascript/components/tooltip';
import Modal from '@slickdeals/blueprint-twig/javascript/components/modal';
import { isMobile } from '@slickdeals/blueprint-twig/javascript/utilities/experience';
import '@slickdeals/blueprint-twig/javascript/components/label';
import '@slickdeals/blueprint-twig/javascript/components/icon';
import '../../scss/patterns/expertLabel.scss';
// The name of the module
export const name = 'ExpertLabel';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-p-expertLabel";
    ClassNames["JavaScript"] = "js-expertLabel";
    ClassNames["ModalContainer"] = "bp-p-expertLabel_modalContainer";
})(ClassNames || (ClassNames = {}));
let ExpertLabel = class ExpertLabel extends BlueprintComponent {
    constructor(options) {
        super(name, options);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.init.call(this);
            this.element = yield BlueprintComponent.loadElement(name, this.options);
            if (isMobile()) {
                this.initModal();
                return;
            }
            this.initTooltip();
        });
    }
    initModal() {
        const fragment = document.createDocumentFragment();
        const body = document.createElement('div');
        body.classList.add(ClassNames.ModalContainer);
        body.appendChild(document.createTextNode(`This user is an Expert in ${this.options.category}`));
        fragment.appendChild(body);
        this.modal = new Modal({
            content: fragment,
            isFixed: true,
        });
        this.element.addEventListener('click', () => this.modal.show());
    }
    initTooltip() {
        this.tooltip = new Tooltip({
            triggerId: this.options.id,
            appendTo: document.body,
            contents: `This user is an Expert in ${this.options.category}`,
            positionAppendTo: [Positions.Bottom, Positions.Left],
        });
    }
};
ExpertLabel = __decorate([
    injectable(name)
], ExpertLabel);
export default ExpertLabel;
BlueprintComponent.instantiate(name);
